import { ZoneView } from "@features/stock/components/ZoneView";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/zones/$id/view")({
  loader: requirePermission(PERMISSIONS.STOCK.ZONES.VIEW),
  component: ViewZoneComponent,
});

function ViewZoneComponent() {
  const { id } = Route.useParams();

  return <ZoneView id={Number(id)} />;
}
